import React from 'react';
import {Flex, Layout, Notes, Diary, Button, Breadcrumbs} from 'components';
import {config} from 'helpers';

export function MorningRoutine() {
  return (
    <>
      <Layout.Header>
        <Flex className="justified">
          <div>
            <Breadcrumbs>
              {config.morningRoutine}
              <b>Morning Thoughts</b>
            </Breadcrumbs>
            <p className="small-spacing">Write down what’s on your mind this morning.</p>
          </div>
          <Button className={['primary', 'small']} to="./plan/" rightIcon="arrow-right">Next</Button>
        </Flex>
      </Layout.Header>
      <div className="sticky-container">
        <Notes.CheckIn>
          <h3>My Notes</h3>
        </Notes.CheckIn>
        <hr />
        <Diary.CheckIn subject="Morning Thoughts" type="morning_thoughts">
          <h3>Focus Questions</h3>
        </Diary.CheckIn>
      </div>
    </>
  );
}
